import { FontFamily } from '@snapchat/snap-design-system-marketing';

import type { FontSettings } from '../configTypes';

/**
 * Default font settings for the site.
 *
 * This file defines the default font families and their associated stylesheets, and font files to
 * be preloaded. These settings are used as a baseline for typography across the site and can be
 * overridden by site-specific config files.
 */
export const defaultFontSettings: FontSettings = [
  {
    name: FontFamily.GHOST_SANS,
    stylesheet: 'https://web-platform.snap.com/fonts/font.ghost-sans.css',
    files: [
      {
        url: 'https://web-platform.snap.com/fonts/ghost-sans/GhostSans-Regular.woff2',
        type: 'font/woff2',
      },
      {
        url: 'https://web-platform.snap.com/fonts/ghost-sans/GhostSans-Medium.woff2',
        type: 'font/woff2',
      },
      {
        url: 'https://web-platform.snap.com/fonts/ghost-sans/GhostSans-SemiBold.woff2',
        type: 'font/woff2',
      },
    ],
  },
  {
    name: FontFamily.PROGRAM,
    stylesheet: 'https://web-platform.snap.com/fonts/font.program.css',
    files: [
      {
        url: 'https://web-platform.snap.com/fonts/program/Program-Regular.woff2',
        type: 'font/woff2',
      },
      {
        url: 'https://web-platform.snap.com/fonts/program/Program-Medium.woff2',
        type: 'font/woff2',
      },
      {
        url: 'https://web-platform.snap.com/fonts/program/Program-Bold.woff2',
        type: 'font/woff2',
      },
      {
        url: 'https://web-platform.snap.com/fonts/program/ProgramNarrow-Regular.woff2',
        type: 'font/woff2',
      },
      {
        url: 'https://web-platform.snap.com/fonts/program/ProgramNarrow-Medium.woff2',
        type: 'font/woff2',
      },
      {
        url: 'https://web-platform.snap.com/fonts/program/ProgramNarrow-Bold.woff2',
        type: 'font/woff2',
      },
    ],
  },
];
